import { Label } from '../Form';
import { Flex } from 'rebass';
import PhoneInputGroup from './PhoneInputGroup';
import { UtilityIconButton } from '../Button/UtilityIconButton';
import React from 'react';
import { EmailInput, PhoneInput } from './types';

type EditPhonesProps = {
  phones: PhoneInput[];
  labels?: boolean;
  singlePhone?: boolean;
  disabled?: boolean;
  handleContactChange: (
    type: 'phone' | 'email',
    value: PhoneInput | EmailInput,
    index: number
  ) => void;
  handleAddPhoneOrEmail: (e: any) => void;
  handleDeletePhoneOrEmail: (idx: number, type: 'phones' | 'emails') => void;
};

const EditPhones: React.FC<EditPhonesProps> = ({
  phones,
  labels,
  singlePhone,
  disabled,
  handleContactChange,
  handleDeletePhoneOrEmail,
  handleAddPhoneOrEmail,
}) => {
  return (
    <>
      {labels && <Label>Phone{singlePhone ? '' : 's'}</Label>}
      {phones &&
        phones.map((phone, idx) => (
          <Flex
            key={idx}
            mb={1}
            sx={{
              alignItems: 'center',
            }}
          >
            <PhoneInputGroup
              mr={singlePhone ? 0 : 1}
              value={phone}
              index={idx}
              onChange={handleContactChange}
              inputProps={{ disabled }}
            />
            {!singlePhone && !disabled && (
              <UtilityIconButton
                dark
                title="Remove Phone"
                icon="x"
                onClick={(e: any) => handleDeletePhoneOrEmail(idx, 'phones')}
              />
            )}
          </Flex>
        ))}
      {!disabled && (!singlePhone || phones.length === 0) && (
        <UtilityIconButton
          dark
          title="Add Phone"
          icon="plus"
          name="phones"
          alignSelf="flex-start"
          onClick={handleAddPhoneOrEmail}
        />
      )}
    </>
  );
};

export default EditPhones;
